import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Address from "../../../../parts/address-component";

class AddressCompanyData extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  UNSAFE_componentWillMount() { }
  render() {
    return (
      <Address viacep />
    );
  }
  componentWillUnmount() { }
}

const mapStateToProps = state => ({
  loading: state.loading,
  
});
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(AddressCompanyData);



// WEBPACK FOOTER //
// ./src/components/pages/branches/create/steps/address.jsx